import React, { Component } from 'react';

export default function TabTitle(props) {
  return <div className="filter-tab">
    <span className={`tab-icon pl ${props.className}`}/>
    {(props.count || props.count === 0) ? <span className="tab-counter">{props.count}</span> : null}
    <span className="tab-text">{props.title}</span>
  </div>;
}
